<div
  class="min-h-screen bg-[#FFFDF5] text-gray-900 font-sans selection:bg-green-500/20 pb-safe"
>
  <!-- Loading State -->
  @if (isLoading$ | async) {
    <div class="flex items-center justify-center min-h-screen">
      <div class="text-center">
        <div
          class="animate-spin rounded-full h-12 w-12 border-4 border-gray-200 mx-auto mb-4"
          [style.borderTopColor]="themeColor"
        ></div>
        <p class="text-gray-600">Loading assignment...</p>
      </div>
    </div>
  } @else if (currentStep$ | async; as currentStep) {
    <!-- Stepper Header (only for steps 1-3, hidden during generation) -->
    @if ((showStepper$ | async) && !(isGenerating$ | async)) {
      <div
        class="bg-white border-b border-gray-100 shadow-sm sticky top-0 z-30"
      >
        <div class="max-w-6xl mx-auto px-4 py-4">
          <!-- Desktop View -->
          <div class="hidden md:flex items-center justify-between relative">
            <div
              class="absolute top-5 -translate-y-1/2 left-5 right-5 h-0.5 bg-gray-200 -z-0"
            ></div>
            <div
              class="absolute top-5 -translate-y-1/2 left-5 h-0.5 transition-all duration-500 ease-in-out -z-0"
              [style.backgroundColor]="themeColor"
              [style.width]="getProgressWidth(currentStep)"
            ></div>

            @for (step of steps; track step.num) {
              <div class="relative z-10 flex flex-col items-center">
                <div
                  class="w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center font-bold text-xs md:text-sm transition-all duration-300 border-2"
                  [class.text-white]="currentStep >= step.num"
                  [class.border-transparent]="currentStep >= step.num"
                  [class.shadow-md]="currentStep >= step.num"
                  [class.bg-white]="currentStep < step.num"
                  [class.border-gray-200]="currentStep < step.num"
                  [class.text-gray-400]="currentStep < step.num"
                  [style.backgroundColor]="
                    currentStep >= step.num ? themeColor : 'white'
                  "
                >
                  @if (currentStep > step.num) {
                    <lucide-icon
                      [img]="icons.CheckCircle2"
                      class="w-5 h-5"
                    ></lucide-icon>
                  } @else {
                    {{ step.num }}
                  }
                </div>
                <span
                  class="mt-2 text-xs font-semibold uppercase tracking-wider transition-colors duration-300"
                  [class.text-gray-900]="currentStep >= step.num"
                  [class.text-gray-400]="currentStep < step.num"
                >
                  {{ step.title }}
                </span>
              </div>
            }
          </div>

          <!-- Mobile View -->
          <div class="md:hidden flex flex-col gap-2">
            <div
              class="flex justify-between items-center text-sm font-bold text-gray-800"
            >
              <div class="flex items-center gap-2">
                @if (isAuthenticated$ | async) {
                  <button
                    type="button"
                    (click)="onExitWizard()"
                    class="w-7 h-7 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-500 hover:text-gray-700 transition-colors cursor-pointer"
                    title="Back to assignments"
                  >
                    <lucide-icon
                      [img]="icons.X"
                      class="w-3.5 h-3.5"
                    ></lucide-icon>
                  </button>
                }
                <span>Step {{ currentStep }} of {{ steps.length }}</span>
              </div>
              <span [style.color]="themeColor">{{
                getStepTitle(currentStep)
              }}</span>
            </div>
            <div class="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden">
              <div
                class="h-full rounded-full transition-all duration-500"
                [style.backgroundColor]="themeColor"
                [style.width]="getMobileProgressWidth(currentStep)"
              ></div>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Main Content -->
    <main class="py-6 px-4 md:px-8">
      @switch (currentStep) {
        @case (1) {
          <app-step-context (next)="onStepNext()"></app-step-context>
        }
        @case (2) {
          <app-step-objective
            (back)="onStepBack()"
            (next)="onStepNext()"
          ></app-step-objective>
        }
        @case (3) {
          <app-step-questions
            (back)="onStepBack()"
            (next)="onStepNext()"
          ></app-step-questions>
        }
        @case (4) {
          <app-step-settings
            (back)="onStepBack()"
            (next)="onStepNext()"
          ></app-step-settings>
        }
        @case (5) {
          <app-step-ready></app-step-ready>
        }
      }
    </main>
  }

  <!-- Exit Wizard Confirmation Dialog -->
  <app-confirm-dialog
    #exitDialog
    title="Leave Assignment Wizard?"
    message="Your progress may not be saved. Are you sure you want to go back to the assignments dashboard?"
    confirmText="Leave"
    cancelText="Stay"
    variant="warning"
    (confirmed)="onExitConfirmed()"
  ></app-confirm-dialog>
</div>
